<placeme-layout-seo [seo]="'homePage.seo' | translate">
  <placeme-home-jumbotron class="main-content"></placeme-home-jumbotron>

  <section class="section-video" id="video">
    <svg preserveAspectRatio="none" viewBox="0 0 1729 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.4782 37.2407L0.998169 21.9019V89.5H1729V21.9019L1632.52 14.2325C1537.48 6.56312 1344.52 -8.77566 1153 6.56312C1067.95 13.375 982.609 26.237 897.24 39.1038C790.378 55.2102 683.466 71.3242 576.998 75.5876C385.478 83.257 192.518 52.5795 97.4782 37.2407Z"
      />
    </svg>
    <placeme-video-block [video]="'homePage.presentation' | translate"></placeme-video-block>
    <svg preserveAspectRatio="none" viewBox="0 0 1728 97" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 90.8635L96 86.1738C192 80.8978 384 70.9322 576 76.2081C768 80.8978 960 101.415 1152 96.1394C1344 90.8635 1536 60.9665 1632 45.7249L1728 30.4832V0H1632C1536 0 1344 0 1152 0C960 0 768 0 576 0C384 0 192 0 96 0H0V90.8635Z"
      />
    </svg>
  </section>

  <placeme-home-spirit></placeme-home-spirit>

  <placeme-home-offer-groups id="offers"></placeme-home-offer-groups>

  <placeme-meeting></placeme-meeting>
</placeme-layout-seo>
